import Bootstrap from '$js/bootstrap';
import imageSliderLoader from '$js/components/image-slider/loader';
import scrollToLoader from '$js/components/scroll-to/loader';
import { navigationBarMain } from '$js/components/navigation/index';
import timetableLoader from '$src/js/components/tables/timetable/loader';
import rankingsLoader from '$src/js/components/tables/rankings/loader';
import faqLoader from '$src/js/components/faq/loader';
import initCookieConsent from '$js/components/cookie-consent';

new Bootstrap();

imageSliderLoader();
scrollToLoader();
navigationBarMain();
timetableLoader();
rankingsLoader();
faqLoader();
initCookieConsent();
